<template>
<div>
  <app-masthead :header="header"/>
    <v-container grid-list-xl>
      <v-layout wrap row class="mb-2">
      <v-flex xs12>
        <h2 style="font-size: 36px; font-weight: bold; line-height: 1.2;" class="mb-2">Wir setzen Impulse!</h2>
        <p>In einer entspannten Runde sprechen wir über verschiedene Themen aus dem Bereich Achtsamkeit, Intuition, Selbstorganisation und Unternehmertum. Um von einem breiten Erfahrungsschatz zu profitieren, laden wir einmal im Monat einen interessanten Gast zu einem speziellen Thema ein.</p>
      </v-flex>
    </v-layout>
    <v-layout  wrap row class="mb-5">
      <v-flex>
        <v-btn flat href="https://itunes.apple.com/de/podcast/impulse/id1453919588?mt=2&app=podcast" target="_blank" style="display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/de-de/badge-lrg.svg?releaseDate=2019-02-22T00:00:00Z&kind=podcast&bubble=podcasts) no-repeat;width:165px;height:40px;"></v-btn>
        <v-btn flat outline href="https://play.spotify.com/show/7teZlpBEhNe5BPjvFBcbpg" target="_blank" color="warning"><v-icon left>open_in_browser</v-icon>auf Spotify</v-btn>
        <v-btn flat outline href="https://ideenpioniere.podigee.io" target="_blank" color="warning"><v-icon left>open_in_browser</v-icon>im Browser</v-btn>
      </v-flex>
    </v-layout>

    <app-cta-newsletter/>
     
  </v-container>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  created() {
    axios.get(this.podcastURL + 'api/podcast?format=json')
    .then(response => {
      // JSON responses are automatically parsed.
      this.posts = response.data
    })
    .catch(e => {
      this.errors.push(e)
    })
  },
  data () {
    return {
      podcastURL: 'https://api.ideenpioniere.de/',
      show: false,
      header: {
        src: require('@/assets/ip-header-podcast.svg'),
        title: 'Wieder. Voneinander. Lernen.',
        description: 'Mit interessanten Gästen sprechen wir über Themen rund um das Entdecken und Umsetzen von Ideen.'
      },
      posts: null
    }
  }
}
</script>
